module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"insect_monitor_v2":"捕虫器センサー(3台)"},"en":{"insect_monitor_v2":"Insect sensors\\n(3 camera)"}}')
  delete Component.options._Ctor
}
